import { unAuthorizedToken } from '../utils/Validations'
import { getAuthToken } from './authHelper';
const server_address = process.env.REACT_APP_SERVER_ADDRESS;

export const validateCenterName = (body) => {
    return fetch(`${server_address}/api/v1/cost-center/validate-center-name`, {
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      }),
      body: JSON.stringify(body),
      method: 'POST'
    }).then((res) => {
       if (res.status === 401) {
        unAuthorizedToken()
      }
      else {
        return res.json();
      }
    })
  }
  
  export const addCostCenter = (body) => {
    return fetch(`${server_address}/api/v1/cost-center/add`, {
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`,
      }),
      body: JSON.stringify(body),
      method: 'POST'
    }).then((res) => {
       if (res.status === 401) {
        unAuthorizedToken()
      }
      else {
        return res.json();
      }
    })
  }
  


// WEBPACK FOOTER //
// ./src/utils/costCenterUtils.js